import { Button } from "@kaltura/ds-react-components";
import { Add24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { CreatePlaylistModal } from "@kaltura/mediaspace-shared-create-playlist-modal";
import { useState } from "react";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

const baseClassName = "kms-ds-my-playlists-filters-section-create-playlist-button";

interface CreatePlaylistProps {
    borderless?: boolean;
}

export const CreatePlaylist = (props: CreatePlaylistProps) => {
    const { borderless = false } = props;
    const [open, setOpen] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const handleClick = () => {
        setOpen(true);
        sendButtonAnalytics("Create Playlist CTA", ButtonClickAnalyticsType.CREATE);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                startIcon={<Add24Icon />}
                className={baseClassName}
                onClick={handleClick}
                variant={borderless ? "borderless" : "pill"}
                color={borderless ? "secondary" : "primary"}
            >
                {translate("Create playlist")}
            </Button>
            <CreatePlaylistModal open={open} onCancel={handleClose} />
        </>
    );
};
